// A faint, traceable diagonal watermark overlay stamped over sensitive media
// so any leaked screenshot carries the viewer's identity.
export function Watermark({ text }) {
  return (
    <div data-testid="watermark" aria-hidden className="pointer-events-none select-none absolute inset-0 overflow-hidden">
      <div className="absolute -inset-1/2 flex flex-wrap gap-x-10 gap-y-8 rotate-[-24deg] content-center justify-center opacity-[0.16]">
        {Array.from({ length: 40 }).map((_, i) => (
          <span key={i} className="text-white text-[11px] tracking-wider whitespace-nowrap">
            {text} · Velluto
          </span>
        ))}
      </div>
    </div>
  );
}
